<template>
  <v-card flat>
    <v-card-title class="subheader py-0">
      <v-icon small class="mr-1" color="indigo">view_list</v-icon>
      申报基本信息
      <v-spacer/>
    </v-card-title>
    <v-divider color="indigo"/>
    <v-card-text class="pt-0">
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 sm8 lg8>
            <div class="x-text-field">
              <label>申报名称</label>
              <div>{{item.name}}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm2 lg2>
            <div class="x-text-field">
              <label>开始时间</label>
              <div>{{item.startDate}}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm2 lg2>
            <div class="x-text-field">
              <label>结束时间</label>
              <div>{{item.finishDate}}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm2 lg2>
            <div class="x-text-field">
              <label>接收开始日期</label>
              <div>{{item.receiveStartDate}}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm2 lg2>
            <div class="x-text-field">
              <label>接收结束日期</label>
              <div>{{item.receiveEndDate}}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm2 lg2>
            <div class="x-text-field">
              <label>评审开始日期</label>
              <div>{{item.reviewStartDate}}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm2 lg2>
            <div class="x-text-field">
              <label>评审结束日期</label>
              <div>{{item.reviewEndDate}}</div>
            </div>
          </v-flex>

          <v-flex xs2 sm2 lg2>
            <div class="x-text-field">
              <label>发起人</label>
              <div>{{item.operator}}</div>
            </div>
          </v-flex>

          <v-flex xs2 sm2 lg2>
            <div class="x-text-field">
              <label>发起时间</label>
              <div>{{item.pubDate}}</div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "Basic",
  props: {
    review: Object
  },
  data: () => ({
    item: {},
    edit: false,
    editDbid: null,
  }),

  watch: {
    review(newVal) {
      window.console.log("review")
      window.console.log(newVal)
      if (newVal) this.item = newVal;
    }
  },
  computed: {
    ...mapGetters(['funcIds'])
  },
}
</script>

<style scoped>

</style>